import { Heading2 } from 'components/shared/Typography.styled';
import styled from 'styled-components';
import { color, container, fontSize, fontWeight, screen, spacing } from 'theme';

export const StyledFooter = styled.div`
  background-color: ${color('midnight_850')};
`;

export const StyledContainer = styled.div`
  max-width: ${container('md')};
  margin: auto;
  padding: 0 ${spacing('md')} ${spacing('xl2')};
  color: ${color('text_white')};
  line-height: 1.5;

  @media (min-width: ${screen('md')}) {
    padding: ${spacing('xl3')} ${spacing('md')} ${spacing('xl4')};
    font-size: ${fontSize('lg')};
    line-height: 1.6;
    text-align: center;

    ${Heading2}::before {
      left: 50%;
      transform: translateX(-50%);
    }
  }
`;

export const StyledCta = styled.div`
  p {
    font-weight: ${fontWeight('extraBold')};

    @media (min-width: ${screen('md')}) {
      font-size: ${fontSize('lg')};
    }
  }
`;
